import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./routes/AdminRoute";
import { AdminProvider } from "./context/AdminContext";
import { InstituteProvider } from "./context/InstituteContext";

import Landing from "./pages/Landing";
import Home from "./pages/Page2_Home";
import Profile from "./pages/Page2a_Profile";
import ScoreBoard from "./pages/Page2b_ScoreBoard";
import Purchases from "./pages/Page2c_Purchase";
import ExamCriteria from "./pages/Page3_ExamCriteria";
import Payment from "./pages/Page4_Payment";
import SelectDateTime from "./pages/Page5_SelectDateTime";
import Examination from "./pages/Page6_Examination";
import Practice from "./pages/Practice";
import Submitted from "./pages/Page7_Submitted";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Accasyllabus from "./pages/Accasyllabus";
import ForgotPassword from "./pages/ForgotPassword";
import BeginnerDashboard from "./pages/BeginnerDashboard";
import BeginnerProfile from "./pages/BeginnerProfile";
import BeginnerPractice from "./pages/BeginnerPractice";
import BeginnerMainExam from "./pages/BeginnerMainExam";
import BeginnerExamCriteria from "./pages/BeginnerExamCriteria";
import BeginnerExamination from "./pages/BeginnerExamination";
import BeginnerResults from "./pages/BeginnerResults";
import BeginnerSubscription from "./pages/BeginnerSubscription";

/* Admin pages */
import AdminDashboard from "./admin/Admindashboard";
import AdminStudents from "./admin/Adminstudents";
import AdminStudentDetail from "./admin/Adminstudentdetail";
import AdminCourses from "./admin/Admincourses";
import AdminExams from "./admin/Adminexams";
import AdminSections from "./admin/Adminsections";
import AdminQuestionBank from "./admin/Adminquestionbank";
import AdminScheduling from "./admin/Adminscheduling";
import AdminRegistrations from "./admin/Adminregistrations";
import AdminPayments from "./admin/Adminpayments";
import AdminResults from "./admin/Adminresults";
import AdminVerification from "./admin/Adminverification";
import AdminProctoring from "./admin/Adminproctorings";
import AdminTodaysExams from "./admin/AdminTodaysExams";
import AdminCouponsPage from "./admin/AdminCouponsPage";
/* NEW: Today's Exams */
// import AdminTodaysExams from "./admin/Admintodaysexams";
import AdminInstitutes from "./admin/Admininstitutes";
import BeginnerAdmin from "./admin/BeginnerAdmin";
import BeginnerResultsAdmin from "./admin/BeginnerResultsAdmin";
import Institutedashboard from "./institute/Institutedashboard";
import Institutepayments from "./institute/Institutepayments";
import Institutestudents from "./institute/Institutestudents";
import Instituteexams from "./institute/Instituteexams";
import InstituteChangePassword from "./institute/InstituteChangePassword";
import InstituteResults from "./institute/Instituteresults";
import InstituteScheduling from "./institute/InstituteScheduling";
import BeginnerSubmitted from "./pages/BeginnerSubmitted";

export default function App() {
  return (
    <AdminProvider>
      <InstituteProvider>
        <Routes>

          {/* =========================
              PUBLIC
          ========================== */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />


          {/* =========================
              STUDENT
          ========================== */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/scoreboard"
            element={
              <ProtectedRoute>
                <ScoreBoard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/purchases"
            element={
              <ProtectedRoute>
                <Purchases />
              </ProtectedRoute>
            }
          />

          <Route
            path="/exam-criteria"
            element={
              <ProtectedRoute>
                <ExamCriteria />
              </ProtectedRoute>
            }
          />

          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />

          <Route
            path="/schedule"
            element={
              <ProtectedRoute>
                <SelectDateTime />
              </ProtectedRoute>
            }
          />

          <Route
            path="/practice"
            element={
              <ProtectedRoute>
                <Practice />
              </ProtectedRoute>
            }
          />

          <Route
            path="/exam"
            element={
              <ProtectedRoute>
                <Examination />
              </ProtectedRoute>
            }
          />

          <Route
            path="/submitted"
            element={
              <ProtectedRoute>
                <Submitted />
              </ProtectedRoute>
            }
          />


          {/* =========================
              ACCA
          ========================== */}
          <Route
            path="/acca-syllabus/:levelId"
            element={
              <ProtectedRoute>
                <Accasyllabus />
              </ProtectedRoute>
            }
          />


          {/* =========================
              ADMIN
          ========================== */}

          {/* /admin redirects to dashboard */}
          <Route
            path="/admin"
            element={
              <Navigate
                to="/admin/dashboard"
                replace
              />
            }
          />

          <Route
            path="/admin/dashboard"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/students"
            element={
              <AdminRoute>
                <AdminStudents />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/students/:studentId"
            element={
              <AdminRoute>
                <AdminStudentDetail />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/courses"
            element={
              <AdminRoute>
                <AdminCourses />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/exams"
            element={
              <AdminRoute>
                <AdminExams />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/sections"
            element={
              <AdminRoute>
                <AdminSections />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/questions"
            element={
              <AdminRoute>
                <AdminQuestionBank />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/schedules"
            element={
              <AdminRoute>
                <AdminScheduling />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/registrations"
            element={
              <AdminRoute>
                <AdminRegistrations />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/payments"
            element={
              <AdminRoute>
                <AdminPayments />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/results"
            element={
              <AdminRoute>
                <AdminResults />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/verification"
            element={
              <AdminRoute>
                <AdminVerification />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/proctoring"
            element={
              <AdminRoute>
                <AdminProctoring />
              </AdminRoute>
            }
          />
          <Route
  path="/admin/coupons"
  element={<AdminCouponsPage />}
/>
          {/* =========================
    BEGINNER STUDENT PORTAL
========================== */}

<Route
  path="/beginner/dashboard"
  element={
    <ProtectedRoute>
      <BeginnerDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/beginner/profile"
  element={
    <ProtectedRoute>
      <BeginnerProfile />
    </ProtectedRoute>
  }
/>
<Route
  path="/beginner/practice"
  element={
    <ProtectedRoute>
      <BeginnerPractice />
    </ProtectedRoute>
  }
/>
<Route
  path="/beginner/main-exam"
  element={
    <ProtectedRoute>
      <BeginnerMainExam />
    </ProtectedRoute>
  }
/>
<Route path="/beginner/exam-criteria/:examAccessId" element={<ProtectedRoute><BeginnerExamCriteria /></ProtectedRoute>} />
<Route path="/beginner/examination/:examAccessId" element={<ProtectedRoute><BeginnerExamination /></ProtectedRoute>} />
<Route path="/beginner/results" element={<ProtectedRoute><BeginnerResults /></ProtectedRoute>} />
<Route
  path="/beginner/subscription"
  element={
    <ProtectedRoute>
      <BeginnerSubscription />
    </ProtectedRoute>
  }
/>
          <Route
  path="/admin/institutes"
  element={
    <AdminRoute>
      <AdminInstitutes />
    </AdminRoute>
  }
/>

<Route
  path="/institute/dashboard"
  element={<Institutedashboard />}
/>
<Route
  path="/institute/payments"
  element={<Institutepayments />}
/>
<Route
  path="/institute/students"
  element={<Institutestudents />}
/>
<Route path="/institute/exams" element={<Instituteexams />} />
<Route
  path="/institute/change-password"
  element={<InstituteChangePassword />}
/>
{/* Institute sub-admin */}
<Route
  path="/institute/results"
  element={<InstituteResults />}
/>
<Route
  path="/institute/scheduling"
  element={<InstituteScheduling />}
/>
          {/* =========================
              NEW: TODAY'S EXAMS
          ========================== */}
          {/* <Route
            path="/admin/todays-exams"
            element={
              <AdminRoute>
                <AdminTodaysExams />
              </AdminRoute>
            } */}
          {/* /> */}
            <Route
  path="/admin/todays-exams"
  element={
    <AdminRoute>
      <AdminTodaysExams />
    </AdminRoute>
  }
/>

          <Route
            path="/admin/beginner"
            element={
              <AdminRoute>
                <BeginnerAdmin />
              </AdminRoute>
            }
          />
          <Route
  path="/beginner/submitted/:attemptId"
  element={<BeginnerSubmitted />}
/>
<Route path="/admin/beginner/results" element={<AdminRoute><BeginnerResultsAdmin /></AdminRoute>} />

          {/* =========================
              UNKNOWN URL
          ========================== */}
          <Route
            path="*"
            element={
              <Navigate
                to="/"
                replace
              />
            }
          />

        </Routes>
      </InstituteProvider>
    </AdminProvider>
    
  );
}
